import React from "react"
import classes from "./Breadcrumbs.module.scss"
import {IBreadCrumbs} from "../../../../models"
import Button from "../../buttons/Button"
import {useNavigate} from "react-router-dom"

interface IBreadcrumbsProps {
  breadcrumbs: IBreadCrumbs
}

function Breadcrumbs({breadcrumbs}: IBreadcrumbsProps) {

  const {items, backUrl} = breadcrumbs
  const breadcrumbsTemplate = items && items.map((item, id) => <div key={id} className={classes.item}>{item}</div>)
  const navigate = useNavigate()

  return (
    <div className={classes.wrap}>
      {backUrl &&
        <Button
          color={"white"}
          size={"sm"}
          onClick={() => navigate(backUrl)}
          icon={"back"}
        >Назад</Button>
      }
      <div className={classes.list}>
        {breadcrumbsTemplate}
      </div>
    </div>
  )
}

export default Breadcrumbs